jQuery(document).ready(function($) {   
  
    /* mobile menu */
    $('.mobile-nav').on('click', '.mobile-nav__top-link-wrap a.mobile-nav__item__top-link', function(e) {
      const href = this.getAttribute('href');
      if (! href || '#' === href) {
        e.preventDefault();
        
        const arrow = $(this).next('a.mobile-nav__arrow');
        if (arrow.length) {
          arrow.click();
        }

        return false;
      } 
    });
  
	$('#sidebar-mobile-nav').on("click", "#accordian a", function() {
      	console.log('Mobile Collection');
      
		var link = $(this);
		var closest_ul = link.closest("ul");
		var parallel_active_links = closest_ul.find(".active")
		var closest_li = link.closest("li");
		var link_status = closest_li.hasClass("active");
		var count = 0;

		closest_ul.find("ul").slideUp(function() {
			if (++count == closest_ul.find("ul").length)
		 		parallel_active_links.removeClass("active");
		});

		if (!link_status) {
        	closest_li.children("ul").slideDown();
          	closest_li.addClass("active");
		}
	})
    
    
    $('#sidebar-mobile-nav').on("click", "#accordian-product-type a", function() {                                     
      	console.log('Mobile Product Type')
        
		var link = $(this);
		var closest_ul = link.closest("ul");
		var parallel_active_links = closest_ul.find(".active")
		var closest_li = link.closest("li");
		var link_status = closest_li.hasClass("active");
		var count = 0;

		closest_ul.find("ul").slideUp(function() {
		if (++count == closest_ul.find("ul").length)
		parallel_active_links.removeClass("active");
		});

		if (!link_status) {
		    closest_li.children("ul").slideDown();
		    closest_li.addClass("active");
		}
	})
    /* end mobile menu*/
    
    /* footer - google review */
    $("a[title=\"Google Reviews\"]").attr("target", "_blank");
    /* end footer - google review */
  
});